import { useState } from "react";
import Popup from "../Popup";

function PopupManager({ popupList = [] }) {
  const [closedPopups, setClosedPopups] = useState([]);

  const handleClose = (popupId) => {
    setClosedPopups((prev) => [...prev, popupId]);
  };

  const visiblePopups = popupList.filter(
    (popup) => !closedPopups.includes(popup.id)
  );

  return (
    <>
      {visiblePopups.map((popup, index) => (
        <Popup
          key={popup.id}
          data={popup}
          index={index}
          onClose={handleClose}
        />
      ))}
    </>
  );
}

export default PopupManager;
